import { useState } from "react";
import { Mail, Phone, IdCard, User, Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { api, errMsg } from "../../lib/api";
import { Stagger, Item } from "../../components/motion";
import { PageHeader, MotionButton, initials } from "../../components/common";

export default function Profile() {
  const { user } = useAuth();
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [state, setState] = useState("idle");
  const rows = [
    [User, "Ad Soyad", user.name, "profile-name"],
    [Phone, "Telefon", user.phone || "—", "profile-phone"],
    [Mail, "E-posta", user.email || "—", "profile-email"],
    [IdCard, "T.C. Kimlik No", user.tc_masked || "—", "profile-tc"],
  ];
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Yeni şifre en az 8 karakter olmalıdır.");
    setState("loading");
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      setState("success");
      toast.success("Şifreniz güncellendi.");
      setCur("");
      setPw("");
      setTimeout(() => setState("idle"), 1200);
    } catch (err) {
      setState("idle");
      toast.error(errMsg(err));
    }
  };
  return (
    <div>
      <PageHeader eyebrow="Hesabım" title="Profilim" desc="Kişisel bilgileriniz ve hesap güvenliğiniz." />
      <Stagger className="grid gap-6 lg:grid-cols-[1.2fr_1fr]" gap={0.1}>
        <Item className="surface p-6 sm:p-8">
          <div className="flex items-center gap-4">
            <div className="grid h-16 w-16 place-items-center rounded-2xl bg-[var(--ink)] text-xl font-extrabold text-white shadow-lg" data-testid="profile-avatar">{initials(user.name)}</div>
            <div>
              <p className="text-xl font-extrabold">{user.name}</p>
              <p className="text-sm text-slate-500">{user.role === "admin" ? "Yönetici" : "Kursiyer"}</p>
            </div>
          </div>
          <dl className="mt-8 divide-y divide-slate-100">
            {rows.map(([Icon, label, val, tid]) => (
              <div key={label} className="flex items-center gap-4 py-4">
                <Icon className="h-5 w-5 text-slate-400" strokeWidth={1.7} />
                <dt className="w-32 text-sm text-slate-500">{label}</dt>
                <dd className="text-sm font-semibold text-[var(--ink)] break-all" data-testid={tid}>{val}</dd>
              </div>
            ))}
          </dl>
          <p className="mt-4 text-xs text-slate-400">Bilgilerinizde değişiklik için eğitim danışmanınızla iletişime geçin.</p>
        </Item>
        <Item className="surface h-fit p-6 sm:p-8">
          <div className="flex items-center gap-2"><Lock className="h-5 w-5 text-[var(--brand)]" /><h2 className="text-lg font-bold">Şifre Değiştir</h2></div>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><label className="mb-1.5 block text-xs font-semibold text-slate-500">Mevcut Şifre</label><input type="password" value={cur} onChange={(e) => setCur(e.target.value)} className="field" data-testid="profile-current-password-input" /></div>
            <div><label className="mb-1.5 block text-xs font-semibold text-slate-500">Yeni Şifre</label><input type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="field" data-testid="profile-new-password-input" /></div>
            <MotionButton type="submit" className="w-full" loading={state === "loading"} success={state === "success"} data-testid="profile-change-password-btn">Şifreyi Güncelle</MotionButton>
          </form>
        </Item>
      </Stagger>
    </div>
  );
}
